import styled from "styled-components";

export const coreFont = styled.div`
    font-family: 'Roboto';
    font-size: 20px;
`